<template>
  <div>
    <top-nav></top-nav>
    <div class="page_content">
      <p class="details_title">辽宁全民健身公共服务平台用户协议</p>
      <p class="details_info">辽宁全民健身公共服务平台与用户共同确认：</p>

      <p class="details_info">
        1.用户点击辽宁全民健身公共服务平台注册页面的注册按钮前应首先阅读《辽宁全民健身公共服务平台用户协议》，如果用户点击注册按钮并完成注册程序、获得辽宁全民健身公共服务平台账号密码时，视为用户与辽宁全民健身公共服务平台已达成《辽宁全民健身公共服务平台用户协议》，就用户进入辽宁全民健身公共服务平台消费（即用户通过辽宁全民健身公共服务平台与场馆商家进行交易）达成本协议的全部约定。
      </p>
      <p class="details_info">
        2.辽宁全民健身公共服务平台及用户均已认真阅读本《辽宁全民健身公共服务平台用户协议》（下称“本协议”）中全部条款及辽宁全民健身公共服务平台发布的其他全部服务条款和操作规则的内容，对本协议及前述服务条款和规则均以知晓、理解并接受，同意将其作为确定双方权利义务的依据。辽宁全民健身公共服务平台《法律声明》为本协议的必要组成部分，用户接受本协议的同时即视为接受辽宁全民健身公共服务平台《法律声明》的全部内容。
      </p>
      <p class="details_info_s">
        一、用户注册
      </p>
      <p class="details_info_s">
        1.1.注册资格
      </p>

      <p class="details_info_s">
        用户承诺：用户具有完全民事权利能力和行为能力注册及应用辽宁全民健身公共服务平台服务。
      </p>
      <p class="details_info_s">
        1.2.注册目的
      </p>
      <p class="details_info_s">
        用户承诺：用户进行用户注册并非出于违反法律法规或破坏辽宁全民健身公共服务平台的交易秩序的目的。
      </p>
      <p class="details_info_s">
        1.3.注册流程
      </p>
      <p class="details_info_s">
        1.3.1.用户同意根据辽宁全民健身公共服务平台用户注册页面的要求提供电话号码等信息，设置辽宁全民健身公共服务平台账号及密码，用户应确保所提供全部信息的真实性、完整性和准确性。
      </p>
      <p class="details_info_s">
        1.3.2.用户获得辽宁全民健身公共服务平台账号及密码时视为用户注册成功，用户同意接收辽宁全民健身公共服务平台发送的与辽宁全民健身公共服务平台网站管理、运营相关的电子邮件和短消息。
      </p>
      <p class="details_info_s">
        1.3.3.用户合法、完整并有效提供注册所需信息的，有权获得辽宁全民健身公共服务平台账号和密码，并成为辽宁全民健身公共服务平台会员，辽宁全民健身公共服务平台账号和密码用于用户在辽宁全民健身公共服务平台进行会员登录。
      </p>
      <p class="details_info_s">
        二、用户服务
      </p>
      <p class="details_info_s">
        辽宁全民健身公共服务平台为用户通过辽宁全民健身公共服务平台进行网络交易活动提供网络交易平台服务，目前辽宁全民健身公共服务平台对用户提供的全民健身公共服务平台网络交易平台服务为免费服务，但辽宁全民健身公共服务平台保留未来对辽宁全民健身公共服务平台网络交易平台服务收取服务费用的权利。
      </p>
      <p class="details_info_s">
        2.1.服务内容
      </p>
      <p class="details_info_s">
        2.1.1.用户有权在辽宁全民健身公共服务平台浏览运动场馆信息、有权通过辽宁全民健身公共服务平台与商家进行场次预订。
      </p>
      <p class="details_info_s">
        2.1.2.用户有权在辽宁全民健身公共服务平台查看其辽宁全民健身公共服务平台会员账号下的信息，有权应用辽宁全民健身公共服务平台提供的功能进行操作。
      </p>
      <p class="details_info_s">
        2.1.3.用户有权按照辽宁全民健身公共服务平台发布的活动规则参与辽宁全民健身公共服务平台组织的网站活动。
      </p>
      <p class="details_info_s">
        2.1.4辽宁全民健身公共服务平台承诺为用户提供的其他服务。
      </p>
      <p class="details_info_s">
        2.2.服务规则
      </p>
      <p class="details_info_s">
        用户承诺遵守下列辽宁全民健身公共服务平台服务规则：
      </p>
      <p class="details_info_s">
        2.2.1.用户应当遵守法律法规、规章、规范性文件及政策要求的规定，不得在辽宁全民健身公共服务平台或利用辽宁全民健身公共服务平台服务从事非法或其他损害辽宁全民健身公共服务平台或第三方权益的活动，如发送或接收任何违法、违规、违反公序良俗、侵犯他人权益的信息，发送或接收传销材料或存在其他危害的信息或言论，未经辽宁全民健身公共服务平台授权使用或伪造辽宁全民健身公共服务平台电子邮件题头信息等。
      </p>
      <p class="details_info_s">
        2.2.2.用户应当遵守法律法规、应当妥善使用和保管辽宁全民健身公共服务平台账号及密码，对其辽宁全民健身公共服务平台账号和密码下进行的行为和发生的事件负责。当用户发现辽宁全民健身公共服务平台账号被未经其授权的第三方使用或存在其他账号安全问题时应立即有效通知辽宁全民健身公共服务平台，要求辽宁全民健身公共服务平台暂停该辽宁全民健身公共服务平台账号的服务。辽宁全民健身公共服务平台有权在合理时间内对用户的该等请求采取行动，但对采取行动前用户已经遭受的损失不承担任何责任。用户在未经辽宁全民健身公共服务平台同意的情况下不得将辽宁全民健身公共服务平台账号以赠与、借用、租用、转让或其他方式处分给他人。
      </p>
      <p class="details_info_s">
        2.2.3.用户通过辽宁全民健身公共服务平台与商家进行运动场馆场次预订时，应当遵守本协议的全部约定及辽宁全民健身公共服务平台发布的其他关于场馆交易的服务条款和操作规则的全部规定。
      </p>
      <p class="details_info_s">
        2.2.4.用户在辽宁全民健身公共服务平台对服务进行评价时应当根据实际情况如实进行评价。
      </p>
      <p class="details_info_s">
        2.2.5.用户应当按照辽宁全民健身公共服务平台发布的规则参加辽宁全民健身公共服务平台抽奖等活动，遵守活动秩序。
      </p>
      <p class="details_info_s">
        2.2.6.辽宁全民健身公共服务平台发布的其他服务条款和操作规则。
      </p>
      <p class="details_info_s">
        三、用户的权利和义务
      </p>
      <p class="details_info_s">
        3.1.用户有权按照本协议约定接受辽宁全民健身公共服务平台提供的辽宁全民健身公共服务平台网络交易平台服务。
      </p>
      <p class="details_info_s">
        3.2.用户有权在注册时选择是否订阅辽宁全民健身公共服务平台发送的关于场馆信息的电子邮件或短消息，并在注册成功后有权随时订阅或退订辽宁全民健身公共服务平台该等信息。
      </p>
      <p class="details_info_s">
        3.3.如用户要求获得场馆的发票、其他付款凭证、购货凭证或服务单据，有权且应当在对场馆进行消费时向场馆方提出，发票金额以实际支付的价款为准。
      </p>
      <p class="details_info_s">
        3.4.用户在消费的过程中，如发现场馆服务与订单内容不符或存在质量、服务态度等其他问题的，应与商家采取协商或其他方式予以解决，辽宁全民健身公共服务平台可向用户提供商家的真实网站登记信息并积极协助用户与商家解决争议。
      </p>
      <p class="details_info_s">
        3.5.用户有权随时终止使用辽宁全民健身公共服务平台服务。
      </p>
      <p class="details_info_s">
        3.6.用户应保证其在注册时和提交订单时所提供的姓名、联系方式、联系地址等全部信息真实、完整、准确，并当上述信息发生变更时及时进行更新提供给辽宁全民健身公共服务平台的信息。
      </p>
      <p class="details_info_s">
        3.7.用户在辽宁全民健身公共服务平台进行交易时不得恶意干扰交易的正常进行、破坏辽宁全民健身公共服务平台的交易秩序。
      </p>
      <p class="details_info_s">
        3.8.用户不得以任何技术手段或其他方式干扰辽宁全民健身公共服务平台的正常运行或干扰其他用户对辽宁全民健身公共服务平台服务的使用。
      </p>
      <p class="details_info_s">
        3.9.用户不得以虚构事实等方式恶意诋毁辽宁全民健身公共服务平台或商家的商誉。
      </p>
      <p class="details_info_s">
        3.10.用户通过辽宁全民健身公共服务平台进行交易应出于真实消费目的，不得以转售等商业目的进行交易。
      </p>
      <p class="details_info_s">
        3.11.用户不得对场馆服务进行虚假评价或虚假投诉。
      </p>
      <p class="details_info_s">
        3.12.用户通过辽宁全民健身公共服务平台发表的信息为公开的信息，其他第三方均可以通过辽宁全民健身公共服务平台获取用户发表的信息，用户对任何信息的发表即认可该信息为公开的信息，并单独对此行为承担法律责任;任何用户不愿被其他第三人获知的信息都不应该在辽宁全民健身公共服务平台上进行发表。
      </p>
      <p class="details_info_s">
        3.13.用户承诺不得以任何方式利用辽宁全民健身公共服务平台直接或间接从事违反中国法律、以及社会公德的行为，辽宁全民健身公共服务平台有权对违反上述承诺的内容予以删除。
      </p>
      <p class="details_info_s">
        四、辽宁全民健身公共服务平台的权利和义务
      </p>
      <p class="details_info_s">
        4.1.如用户不具备本协议约定的注册资格，则辽宁全民健身公共服务平台有权拒绝用户进行注册，对已注册的用户有权注销其辽宁全民健身公共服务平台会员账号，辽宁全民健身公共服务平台因此而遭受损失的，有权向前述用户主张赔偿。同时，辽宁全民健身公共服务平台保留其他任何情况下决定是否接受用户注册的权利。
      </p>
      <p class="details_info_s">
        4.2.辽宁全民健身公共服务平台发现账户使用者并非账户初始注册人时，有权中止该账户的使用。
      </p>
      <p class="details_info_s">
        4.3.辽宁全民健身公共服务平台通过技术检测、人工抽检等检测方式合理怀疑用户提供的信息错误、不实、失效或不完整时，有权通知用户更正、更新信息或中止、终止为其提供辽宁全民健身公共服务平台服务。
      </p>

      <p class="details_info_s">
        4.4.辽宁全民健身公共服务平台有权在发现辽宁全民健身公共服务平台上显示的任何信息存在明显错误时，对信息予以更正。
      </p>
      <p class="details_info_s">
        4.5.用户付款成功前，辽宁全民健身公共服务平台有权接受商家委托对订单内容作出变更，如用户接受变更后的内容则用户可确认订单及付款，如用户不接受变更后内容则有权取消订单。用户付款成功后，如确因情况变化导致商家需对订单内容作出变更的，辽宁全民健身公共服务平台有权接受商家委托单方对订单内容作出变更，如用户接受变更则按变更后的订单内容进行消费，如用户不接受变更则用户有权取消订单并要求辽宁全民健身公共服务平台代商家全额退款。
      </p>
      <p class="details_info_s">
        4.6.辽宁全民健身公共服务平台保留随时修改、中止或终止辽宁全民健身公共服务平台服务的权利，辽宁全民健身公共服务平台行使修改或中止服务的权利不需事先告知用户，辽宁全民健身公共服务平台终止辽宁全民健身公共服务平台一项或多项服务的，终止自辽宁全民健身公共服务平台在网站上发布终止公告之日生效。
      </p>
      <p class="details_info_s">
        4.7.辽宁全民健身公共服务平台应当采取必要的技术手段和管理措施保障辽宁全民健身公共服务平台的正常运行，并提供必要、可靠的交易环境和交易服务，维护交易秩序。
      </p>
      <p class="details_info_s">
        4.8.如用户连续一年未使用辽宁全民健身公共服务平台会员账号和密码登录辽宁全民健身公共服务平台，则辽宁全民健身公共服务平台有权注销用户的辽宁全民健身公共服务平台账号。账号注销后，辽宁全民健身公共服务平台有权将相应的会员名开放给其他用户注册使用。
      </p>
      <p class="details_info_s">
        4.9.辽宁全民健身公共服务平台有权在本协议履行期间及本协议终止后保留用户的注册信息及用户应用辽宁全民健身公共服务平台服务期间的全部交易信息，但不得非法使用该等信息。
      </p>
      <p class="details_info_s">
        4.10.辽宁全民健身公共服务平台有权随时删除辽宁全民健身公共服务平台网站内各类不符合国家法律法规、规范性文件或辽宁全民健身公共服务平台网站规定的用户评价等内容信息，辽宁全民健身公共服务平台行使该等权利不需提前通知用户。
      </p>

      <p class="details_info_s">
        五、特别声明
      </p>
      <p class="details_info_s">
        5.1.用户未通过辽宁全民健身公共服务平台与商家之间进行的交易不属于辽宁全民健身公共服务平台的交易，辽宁全民健身公共服务平台对不属于辽宁全民健身公共服务平台交易的交易事项不承担任何责任，用户不得因其与商家之间因此类交易发生的任何争议投诉辽宁全民健身公共服务平台或要求辽宁全民健身公共服务平台承担任何责任。不属于辽宁全民健身公共服务平台交易的情况具体包括：用户未在辽宁全民健身公共服务平台与商家成立订单;用户虽在辽宁全民健身公共服务平台与商家成立订单，但未通过辽宁全民健身公共服务平台而直接向商家支付价款。
      </p>
      <p class="details_info_s">
        5.2.不论在何种情况下，辽宁全民健身公共服务平台对由于信息网络设备维护、信息网络连接故障、电脑、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务不承担责任。
      </p>
      <p class="details_info_s">
        5.3.为了用户更加方便和安全的使用辽宁全民健身公共服务平台的服务，辽宁全民健身公共服务平台将使用cookie，收集用户与辽宁全民健身公共服务平台站点有关的特征信息，用于标识用户的设备。同时，辽宁全民健身公共服务平台会积极采取先进的技术手段和有效的管理机制来保障用户的账户安全，保障用户的隐私信息不被任何未授权的使用或者泄露。
      </p>
      <p class="details_info_s">
        六、知识产权
      </p>
      <p class="details_info_s">
        6.1.辽宁全民健身公共服务平台所包含的全部智力成果包括但不限于数据库、网站设计、文字和图表、软件、照片、录像、音乐、声音及其前述组合，软件编译、相关源代码和软件（包括小应用程序和脚本）的知识产权权利均归辽宁全民健身公共服务平台所有。用户不得为商业目的复制、更改、拷贝、发送或使用前述任何材料或内容。
      </p>
      <p class="details_info_s">
        6.2.辽宁全民健身公共服务平台名称中包含的所有权利（包括商誉和商标）均归辽宁全民健身公共服务平台所有。
      </p>
      <p class="details_info_s">
        6.3.用户接受本协议即视为用户主动将其在辽宁全民健身公共服务平台发表的任何形式的信息的著作权，包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利无偿独家转让给辽宁全民健身公共服务平台所有，辽宁全民健身公共服务平台有权利就任何主体侵权单独提起诉讼并获得全部赔偿。本协议属于《中华人民共和国著作权法》第二十五条规定的书面协议，其效力及于用户在辽宁全民健身公共服务平台发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。
      </p>

      <p class="details_info_s">
        6.4.用户在使用辽宁全民健身公共服务平台服务过程中，不得非法使用或触犯辽宁全民健身公共服务平台或他人的知识产权权利。用户不得将已发表于辽宁全民健身公共服务平台的信息以任何形式发布或授权其它网站（及媒体）使用。
      </p>
      <p class="details_info_s">
        七、客户服务
      </p>
      <p class="details_info_s">
        辽宁全民健身公共服务平台建立专业的客服团队，并建立完善的客户服务制度，从技术、人员和制度上保障用户提问及投诉渠道的畅通，为用户提供及时的疑难解答与投诉反馈。
      </p>
      <p class="details_info_s">
        八、协议的变更和终止
      </p>
      <p class="details_info_s">
        8.1.协议的变更辽宁全民健身公共服务平台有权随时对本协议内容或辽宁全民健身公共服务平台发布的其他服务条款及操作规则的内容进行变更，变更时辽宁全民健身公共服务平台将在辽宁全民健身公共服务平台网站显著位置内发布公告，变更自公告发布之时生效，如用户继续使用辽宁全民健身公共服务平台提供的服务即视为用户同意该等内容变更，如用户不同意变更后的内容则用户有权注销辽宁全民健身公共服务平台账户、停止使用辽宁全民健身公共服务平台服务。
      </p>
      <p class="details_info_s">
        8.2.协议的终止
      </p>
      <p class="details_info_s">
        8.2.1.辽宁全民健身公共服务平台有权依据本协议约定注销用户的辽宁全民健身公共服务平台账号，本协议于账号注销之日终止。
      </p>
      <p class="details_info_s">
        8.2.2.辽宁全民健身公共服务平台有权依据本协议约定终止全部辽宁全民健身公共服务平台服务，本协议于辽宁全民健身公共服务平台全部服务终止之日终止。
      </p>
      <p class="details_info_s">
        8.2.3.本协议终止后，用户无权要求辽宁全民健身公共服务平台继续向其提供任何服务或履行任何其他义务，包括但不限于要求辽宁全民健身公共服务平台为用户保留或向用户披露其原辽宁全民健身公共服务平台账号中的任何信息，向用户或第三方转发任何其未曾阅读或发送过的信息等。
      </p>
      <p class="details_info_s">
        8.2.4.本协议的终止不影响守约方向违约方追究违约责任。
      </p>
      <p class="details_info_s">
        九、违约责任
      </p>
      <p class="details_info_s">
        9.1.辽宁全民健身公共服务平台或用户违反本协议的约定即构成违约，违约方应当向守约方承担违约责任。
      </p>
      <p class="details_info_s">
        9.2.如用户违反本协议约定，以转售等商业目的进行交易，则辽宁全民健身公共服务平台有权代商家取消相关交易，并有权注销其辽宁全民健身公共服务平台账号，终止为其提供辽宁全民健身公共服务平台服务，如辽宁全民健身公共服务平台因此而遭受损失的，有权要求用户赔偿损失。
      </p>

      <p class="details_info_s">
        9.3.如因用户提供的信息不真实、不完整或不准确给辽宁全民健身公共服务平台或商家造成损失的，辽宁全民健身公共服务平台有权要求用户对辽宁全民健身公共服务平台或对商家进行损失的赔偿。
      </p>
      <p class="details_info_s">
        9.4.如因用户违反法律法规规定或本协议约定，在辽宁全民健身公共服务平台或利用辽宁全民健身公共服务平台服务从事非法活动的，辽宁全民健身公共服务平台有权立即终止继续对其提供辽宁全民健身公共服务平台服务，注销其账号，并要求其赔偿由此给辽宁全民健身公共服务平台造成的损失。
      </p>
      <p class="details_info_s">
        9.5.如用户以技术手段干扰辽宁全民健身公共服务平台的运行或干扰其他用户对辽宁全民健身公共服务平台使用的，辽宁全民健身公共服务平台有权立即注销其辽宁全民健身公共服务平台账号，并有权要求其赔偿由此给辽宁全民健身公共服务平台造成的损失。
      </p>
      <p class="details_info_s">
        9.6.如用户以虚构事实等方式恶意诋毁辽宁全民健身公共服务平台或商家的声誉，辽宁全民健身公共服务平台有权要求用户向辽宁全民健身公共服务平台或商家公开道歉，赔偿其给辽宁全民健身公共服务平台或商家造成的损失，并有权终止对其提供辽宁全民健身公共服务平台服务。
      </p>
      <p class="details_info_s">
        十、争议解决
      </p>
      <p class="details_info_s">
        用户与辽宁全民健身公共服务平台因本协议的履行发生争议的应通过友好协商解决，协商解决不成的，任何一方均可向辽宁呼和浩特市人民法院提起诉讼。
      </p>
      <p class="details_info_s">
        十一、协议生效
      </p>
      <p class="details_info_s">
        本协议于用户点击辽宁全民健身公共服务平台注册页面的同意注册并完成注册程序、获得辽宁全民健身公共服务平台账号和密码时生效，对辽宁全民健身公共服务平台和用户均具有约束力。
      </p>
    </div>
    <bot-nav></bot-nav>
  </div>
</template>

<script>
export default {
  name: "termService"
}
</script>


<style scoped lang="less">
.page_content {
  padding: 19px 100px 0px 100px;

  p {
    margin: 0;
    padding: 0;
  }

  .details_title {
    font-size: 48px;
    color: #333;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
  }

  .details_info {
    font-weight: 400;
    font-size: 24px;
    color: #000;
    margin-bottom: 20px;
    text-indent: 2em
  }

  .details_info_s {
    font-weight: 400;
    font-size: 24px;
    color: #000;
    margin-bottom: 20px;
    text-indent: 3em
  }

  .details_point {
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    margin-bottom: 20px;
    padding: 0 0 0 20px;
    text-align: left;
    text-justify: unset;
    line-height: 40px;
  }
}

.pic_con {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;

  img {
    width: 60%;
  }
}

</style>
